var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { HttpClient } from '@angular/common/http';
var IntegrationsImportService = /** @class */ (function () {
    function IntegrationsImportService(http) {
        this.http = http;
    }
    IntegrationsImportService.prototype.fetch = function (params) {
        return this.http.post('/integration/import/fetch', params);
    };
    IntegrationsImportService.prototype.fetchErrors = function (filter) {
        return this.http.post('/integration/import/error/fetch', filter);
    };
    IntegrationsImportService.prototype.getPagerIndexReset = function (pager) {
        return pager ? __assign({}, pager, { pageIndex: 0 }) : null;
    };
    return IntegrationsImportService;
}());
export { IntegrationsImportService };
